import React, { Component } from 'react';
import renderChildUIComponents from "./metadata-mapper";
import Loading from '../Loading'
import {observer} from "mobx-react";
import { FlatDomainDataContext, FormBean, IDomainMetadata, IUIViewDef, IViewContext } from '../../datatypes';

const {MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon} = require('mdbreact');

interface Props {
    isModal:boolean;
    formBean: FormBean;
    metadata: IUIViewDef;
    isLoading:boolean;
    ctx:FlatDomainDataContext;
}
export default observer(class ModalPage extends Component<Props,{}> {

    onClickClose = () => {
        this.props.formBean.__ui__only.enablePopUpView = false;
    }

  render() {
    const {width} = this.props.metadata;
    return (
        <MDBContainer>
            <MDBModal size={width || "md"} id="uiRendererPopupModal" className={'uiRenderer-modal'} 
                      keyboard={false} disableBackdrop={true} 
                      isOpen={this.props.formBean.__ui__only.enablePopUpView}>
                <div><MDBIcon onClick={this.onClickClose} className={"closeIcon-modal-popup"} icon={'times'}/></div>
                <MDBModalBody>
              <div>
                  {this.props.isLoading ? <Loading/> : renderChildUIComponents(this.props)}
              </div>
            </MDBModalBody>
          </MDBModal>
        </MDBContainer>

    );
  }
});